import { Row, Col } from "antd";
import { Typography } from "@mui/material";
import moment from 'moment';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";

export const HeaderView = (props) => {
    const { classes, clsx, form, status, view, changeHandler, unitMesurementdetails, idNamingConversion, customObject } = props;

    return (
        <>
            <Row gutter={50}>
                <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Stock Count Number</Typography>
                            <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'} </Typography>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <span className={clsx(classes.statusButton, { [classes.confirmedButton]: status === 'CONFIRMED' })}>{status || 'CREATED'}</span>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            {
                                view ? <>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default Unit</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.unit?.name || '---'} </Typography>
                                </> : <AutoCompleteComponent
                                    name={["Default Unit "]}
                                    heads={[{ 'key': 'name', 'name': 'Unit' },
                                    { 'key': 'description', 'name': 'Description' }]}
                                    details={unitMesurementdetails}
                                    parentValue={customObject(unitMesurementdetails, form?.unitId)}
                                    id={idNamingConversion('Unit', 'salesBillLine', 'DropDown')}
                                    onChange={(data) => changeHandler(data, 'unitId', 'unit')}
                                    position={"bottom"}
                                />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Created Date</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.createTs ? moment(form.createTs).format('DD MMM YYYY') : '---'}</Typography>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Updated Date</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.updateTs ? moment(form.updateTs).format('DD MMM YYYY') : '---'}</Typography>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>User Name</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createdBy || '---'}</Typography>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Updated User Name</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.updatedBy || '---'}</Typography>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}